import request from '@/axios/index.js'
export function invoiceContractList(data,loading) {
    return request.axios({
        url: `/invoice/contract/invoiceContractList`,
        data: data,
        loading:loading
    })
}

export function saveOrUpdateContract(data) {
    return request.axios({
        url: `/invoice/contract/saveOrUpdateContract`,
        data: data
    })
}

export function getContractInfo(id) {
    return request.axios({
        url: `/invoice/contract/getContractById/${id}`,
    })
}


//修改判断
export function updateContractFlag(id) {
    return request.axios({
        url: `/invoice/contract/updateContractFlag/${id}`,
    })
}




//解除
export function unMatchMainContract(data) {
    return request.axios({
        url: `/invoice/contract/unMatchMainContract`,
        data:data
    })
}

//匹配
export function matchMainContract(data) {
    return request.axios({
        url: `/invoice/contract/matchMainContract`,
        data:data
    })
}













// WEBPACK FOOTER //
// ./src/api/orderContract.js